import { html } from '@tamagui/tailwind'
import type { ReactNode } from 'react'

// Label + control + hint + error. Visible label always, never a placeholder standing in for one.
export function FormField({
  id,
  label,
  hint,
  error,
  required,
  children,
}: {
  id: string
  label: string
  hint?: string
  error?: string
  required?: boolean
  children: ReactNode
}) {
  return (
    <html.div className="flex flex-col gap-1">
      <html.label
        htmlFor={id}
        className="text-sm font-semibold text-color"
      >
        {label}
        {required ? ' *' : ''}
      </html.label>
      {children}
      {hint && !error ? (
        <html.p
          id={`${id}-hint`}
          className="text-sm text-color-tertiary"
        >
          {hint}
        </html.p>
      ) : null}
      {error ? (
        <html.p
          id={`${id}-error`}
          role="alert"
          className="text-sm text-danger"
        >
          {error}
        </html.p>
      ) : null}
    </html.div>
  )
}
